import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronUp, Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [issOpen, setIssOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIssOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const services = [
    { name: "Personal Taxation", link: "/personaltax" }, 
    { name: "Franchise Accounting", link: "/franchise" },
    { name: "Business Taxation", link: "/businesstaxation" },
    { name: "General Accounting", link: "/generaltax" },
    { name: "Business Registration", link: "/businessregistration" },
    { name: "Budgeting & Cash Flow", link: "/cashflow" },
    { name: "Filing Government Tax Returns", link: "/fillingreturns" },
  ];

  return (
    <header>
      <div className="mx-auto px-4 sm:px-6 lg:px-32">
        <div className="flex justify-between items-center py-2">
          {/* Logo */}
          <div className="xl:text-2xl font-bold text-gray-900">
            <Link to="/"> <img className=" w-20  h-12" src="images/aclogo.png"></img>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex gap-12 xl:gap-20 font-bold">
            <Link to="/aboutus" className="text-gray-700 text-lg hover:text-slate-900">
              About Us
            </Link>

            {/* Desktop Services Dropdown */}
            <div className="relative inline-block" ref={dropdownRef}>
              <button
                onMouseEnter={() => setIssOpen(true)}
                className="flex items-center text-gray-700 text-lg hover:text-slate-900 transition-all"
              >
                Services <ChevronDown className="ml-2 w-4 h-4" />
              </button>

              {issOpen && (
                <ul
                  className="absolute left-1/2 -translate-x-1/2 mt-2 w-80 z-30 bg-white border border-gray-200 rounded-lg shadow-lg"
                  onMouseLeave={() => setIssOpen(false)}
                >
                  {services.map((service, index) => (
                    <li
                      key={index}
                      className="px-4 py-3 hover:bg-slate-900 text-center font-semibold hover:text-white cursor-pointer"
                      onClick={() => {
                        navigate(service.link);
                        setIssOpen(false);
                      }}
                    >
                      {service.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <Link to="/forms" className="text-gray-700 text-lg hover:text-slate-900">
              Forms
            </Link>
            <Link to="/contactus" className="text-gray-700 text-lg hover:text-slate-900">
              Contact Us
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden flex flex-col items-center space-y-4 py-4">
            <Link to="/aboutus" className="text-gray-700 hover:text-slate-900" onClick={() => setIsOpen(false)}>
              About Us
            </Link>

            {/* Mobile Services Dropdown */}
            <div className="w-full text-center">
              <button
                onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                className="flex items-center justify-center text-gray-700 hover:text-slate-900 w-full"
              >
                Services {mobileServicesOpen ? <ChevronUp className="ml-2 w-4 h-4" /> : <ChevronDown className="ml-2 w-4 h-4" />}
              </button>

              {mobileServicesOpen && (
                <ul className="bg-gray-100 w-full rounded-lg mt-2">
                  {services.map((service, index) => (
                    <li
                      key={index}
                      className="py-2 hover:bg-slate-900 hover:text-white cursor-pointer"
                      onClick={() => {
                        navigate(service.link);
                        setIsOpen(false);
                        setMobileServicesOpen(false);
                      }}
                    >
                      {service.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <Link to="/forms" className="text-gray-700 hover:text-slate-900" onClick={() => setIsOpen(false)}>
              Forms
            </Link>
            <Link to="/contactus" className="text-gray-700 hover:text-slate-900" onClick={() => setIsOpen(false)}>
              Contact Us
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;


// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { ChevronDown, Menu, X } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [issOpen, setIssOpen] = useState(false);

//   const dropdownRef = useRef(null);
//   const navigate = useNavigate(); // React Router navigation hook

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIssOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const services = [
//     { name: " Personal Taxation", link: "/personaltax" }, 
//     { name: "Franchise Accounting", link: "/franchise" },
//     { name: " Business Taxation", link: "/businesstaxation" },
//     { name: " General Accounting", link: "/generaltax" },
//     { name: "Business Registration", link: "/businessregistration" },
//     { name: "Budgeting & Cash Flow", link: "/cashflow" },
//     { name: "Filing Government Tax Returns", link: "/fillingreturns" },

//   ];

//   return (
//     <header className=" ">
//       <div className=" mx-auto px-4 sm:px-6 lg:px-32">
//         <div className="flex justify-between items-center py-4">
//           {/* Logo */}
//           <div className="xl:text-2xl font-bold text-gray-900">
//             <Link to="/">Pankaj Aggarwal Tax & Accounting Services</Link>
            
//           </div>

//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex gap-8 2xl:space-x-20 font-bold">
//           <Link to="/aboutus" className="text-gray-700 text-lg hover:text-slate-900">
//             About Us
//             </Link>
//             <div className="relative inline-block " ref={dropdownRef}>
//       {/* Button */}
//       <button
//         onMouseEnter={() => setIssOpen(true)}
//         className="flex items-center text-gray-700 text-lg hover:text-slate-900 transition-all"
//       >
//         Services <ChevronDown className="ml-2 w-4 h-4" />
//       </button>

//       {/* Dropdown Menu */}
//       {issOpen && (
//         <ul
//           className="absolute left-1/2 -translate-x-1/2 mt-2 w-80 z-30 bg-white border border-gray-200 rounded-lg shadow-lg transition-all duration-200 opacity-100"
//           onMouseLeave={() => setIssOpen(false)}
//         >
//           {services.map((service, index) => (
//             <li
//               key={index}
//               className="px-4 py-3 hover:bg-slate-900 text-center font-semibold hover:text-white cursor-pointer transition-all"
//               onClick={() => {
//                 if (service.link !== "#") {
//                   navigate(service.link); // Navigate to the franchise page
//                 }
//                 setIssOpen(false); // Close dropdown on click
//               }}
//             >
//               {service.name}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>

//             {/* <Link to="/services" className="text-gray-700 text-lg hover:text-slate-900">
//               Services
//             </Link> */}
            
//             <Link to="/forms" className="text-gray-700 text-lg hover:text-slate-900">
//              Forms
//             </Link>
//             <Link to="/contactus" className="text-gray-700 text-lg hover:text-slate-900">
//               Contact us
//             </Link>
//           </nav>

//           {/* Mobile Menu Button */}
//           <button
//             className="md:hidden text-gray-700 focus:outline-none"
//             onClick={() => setIsOpen(!isOpen)}
//           >
//             {isOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {isOpen && (
//           <div className="md:hidden flex flex-col items-center space-y-4 py-4">
          
//             <Link to="/services" className="text-gray-700 hover:text-slate-900" onClick={() => setIsOpen(false)}>
//               SERVICES
//             </Link>

//             <Link to="/forms" className="text-gray-700  hover:text-slate-900">
//              Forms
//             </Link>
//             <Link to="/aboutus" className="text-gray-700 hover:text-slate-900" onClick={() => setIsOpen(false)}>
//               About Us
//             </Link>
//             <Link to="/contactus" className="text-gray-700 hover:text-slate-900" onClick={() => setIsOpen(false)}>
//               Contact Us
//             </Link>
//           </div>
//         )}
//       </div>
//     </header>
//   );
// };

// export default Header;
